import { Helmet } from 'react-helmet-async';

const SEO = () => {
  const siteTitle = "Cristian Vásquez Aburto - Contador Especialista en Tributación | Osorno, Chile";
  const siteDescription = "Servicios contables, tributarios y laborales en Osorno, Chile. Asesoría profesional con transparencia para tu empresa. Especialista en tributación nacional, gestión laboral y contabilidad general.";
  const siteUrl = "https://tudominio.cl"; // Reemplazar con el dominio real
  const siteImage = "https://customer-assets.emergentagent.com/job_cristian-contador/artifacts/dvmwtzc5_Dise%C3%B1o%20sin%20t%C3%ADtulo.png";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content="contador osorno, asesoría tributaria chile, servicios contables osorno, gestión laboral chile, contador tributario, boletas de honorarios, declaraciones mensuales, outsourcing contable, contador independiente osorno, asesoría contable pymes" />
      <meta name="author" content="Cristian Vásquez Aburto" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="geo.region" content="CL-LL" />
      <meta name="geo.placename" content="Osorno" />
      <meta name="geo.position" content="-40.573125;-73.135485" />
      <meta name="ICBM" content="-40.573125, -73.135485" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:locale" content="es_CL" />
      <meta property="og:site_name" content="Cristian Vásquez Aburto - Contador" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={siteDescription} />
      <meta property="twitter:image" content={siteImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl} />

      {/* Structured Data - LocalBusiness */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AccountingService",
          "name": "Cristian Vásquez Aburto - Contador",
          "image": siteImage,
          "description": siteDescription,
          "url": siteUrl,
          "telephone": "+56984174768",
          "email": "contacto@cristianvasquezcontador.cl",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Bilbao 1174 Oficina 5",
            "addressLocality": "Osorno",
            "addressRegion": "Los Lagos",
            "postalCode": "5290000",
            "addressCountry": "CL"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": -40.573125,
            "longitude": -73.135485
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ],
            "opens": "09:00",
            "closes": "18:00"
          },
          "priceRange": "$$",
          "areaServed": {
            "@type": "City",
            "name": "Osorno"
          },
          "founder": {
            "@type": "Person",
            "name": "Cristian Vásquez Aburto",
            "jobTitle": "Contador Especialista en Tributación",
            "alumniOf": [
              {
                "@type": "CollegeOrUniversity",
                "name": "Universidad de Los Lagos"
              },
              {
                "@type": "Organization",
                "name": "Thomson Reuters"
              },
              {
                "@type": "CollegeOrUniversity",
                "name": "Pontificia Universidad Católica de Valparaíso"
              }
            ]
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Servicios Contables",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Contabilidad General",
                  "description": "Balances, estados financieros y orden administrativo completo"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Gestión Laboral",
                  "description": "Liquidaciones de sueldo, declaraciones juradas y gestión de personal"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Asesoría Tributaria",
                  "description": "Planificación fiscal, gestión de impuestos y optimización tributaria"
                }
              }
            ]
          }
        })}
      </script>

      {/* Structured Data - Person */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "Cristian Vásquez Aburto",
          "jobTitle": "Contador Especialista en Tributación",
          "description": "Contador profesional con especialización en tributación nacional, gestión laboral y contabilidad general",
          "url": siteUrl,
          "image": siteImage,
          "telephone": "+56984174768",
          "email": "contacto@cristianvasquezcontador.cl",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Bilbao 1174 Oficina 5",
            "addressLocality": "Osorno",
            "addressRegion": "Los Lagos",
            "addressCountry": "CL"
          },
          "worksFor": {
            "@type": "Organization",
            "name": "Contador Independiente"
          },
          "sameAs": [
            "https://wa.me/56984174768",
            "https://www.instagram.com/cristian.vasquez.contador/"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
